import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { Banner, messageOf } from "./ui";

type Preview = { id: string; suggested_mapping: Record<string, string | null>; preview: (string | number | null)[][]; sheets: { name: string; row_count: number; headers: string[] }[] };

export function ImportPage() {
  const [job, setJob] = useState<Preview | null>(null);
  const [mapped, setMapped] = useState<{ preview: { row_number: number; errors: string[]; fields: Record<string, unknown> }[] } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [note, setNote] = useState<string | null>(null);

  return (
    <>
      <header className="page-head">
        <div>
          <h1>Εισαγωγή</h1>
          <p className="lede">Αναγνωρίζονται ελληνικές κεφαλίδες, ευρωπαϊκά δεκαδικά και ημερομηνίες ημέρα-μήνας-έτος. Γραμμή με λάθος ημερομηνία ή χωρίς όνομα μένει στη λίστα σφαλμάτων. Οι τύποι δεν εκτελούνται. <a href="/samples/inquiries.csv">Δείγμα αρχείου</a>.</p>
        </div>
      </header>
      <Banner error={error} note={note} />
      <form
        className="panel"
        onSubmit={(event) => {
          event.preventDefault();
          const form = new FormData(event.currentTarget);
          setError(null);
          void fetch("/api/imports", { method: "POST", body: form, credentials: "same-origin" })
            .then(async (response) => {
              const data = await response.json() as Preview & { error?: { message?: string } };
              if (!response.ok) throw new Error(data.error?.message || "Η μεταφόρτωση απέτυχε.");
              setJob(data);
              setMapped(null);
            })
            .catch((reason: unknown) => setError(messageOf(reason)));
        }}
      >
        <label>CSV ή Excel<input name="file" type="file" accept=".csv,.xlsx" required /></label>
        <button type="submit">Προεπισκόπηση</button>
      </form>
      {job ? (
        <section className="panel" style={{ marginTop: 16 }}>
          <h2>{job.sheets[0]?.name} · {job.sheets[0]?.row_count} γραμμές</h2>
          <p className="meta">Προτεινόμενη αντιστοίχιση: {Object.entries(job.suggested_mapping).filter(([, value]) => value).map(([header, field]) => `${header} → ${field}`).join(", ") || "καμία"}</p>
          <table>
            <tbody>
              {job.preview.map((row, index) => <tr key={index}>{row.map((cell, cellIndex) => <td key={cellIndex}>{String(cell ?? "")}</td>)}</tr>)}
            </tbody>
          </table>
          <div className="actions">
            <button type="button" onClick={() => void api<{ preview: { row_number: number; errors: string[]; fields: Record<string, unknown> }[] }>(`/api/imports/${job.id}/map`, { method: "POST", body: JSON.stringify({ mapping: job.suggested_mapping, decimal: "," }) }).then((result) => setMapped(result)).catch((reason: unknown) => setError(messageOf(reason)))}>Ελεγχος γραμμών</button>
            <button type="button" onClick={() => void api<{ created_event_ids: string[]; errors: { row_number: number }[] }>(`/api/imports/${job.id}/commit`, { method: "POST", body: JSON.stringify({}) }).then((result) => setNote(`Δημιουργήθηκαν ${result.created_event_ids.length} εκδηλώσεις. ${result.errors.length} γραμμές έμειναν ως σφάλματα.`)).catch((reason: unknown) => setError(messageOf(reason)))}>Καταχώριση έγκυρων γραμμών</button>
          </div>
          {mapped ? (
            <ul>
              {mapped.preview.map((row) => (
                <li key={row.row_number}>Γραμμή {row.row_number}: {row.errors.length ? row.errors.join(" ") : `έτοιμη · ${String(row.fields.contact_name ?? "")}`}</li>
              ))}
            </ul>
          ) : null}
          <p><Link to="/pipeline">Ανοιγμα εκδηλώσεων</Link></p>
        </section>
      ) : null}
    </>
  );
}
